import { Link } from 'react-router-dom';
import styles from './Breadcrumb.module.css';

export default function Breadcrumb({ items }) {
    const visibleItems = items.filter(Boolean);
    return <nav className={styles.breadcrumb} aria-label="Percorso di navigazione">
        <ol>{visibleItems.map((item, index) => <li key={`${item.to || 'current'}-${index}`}>
            {index > 0 && <span className={styles.separator} aria-hidden="true">›</span>}
            {item.to && index !== visibleItems.length - 1
                ? <Link to={item.to} title={item.label} onClick={item.onClick}>{item.label}</Link>
                : <span className={styles.current} aria-current={index === visibleItems.length - 1 ? 'page' : undefined} title={item.label}>{item.label}</span>}
        </li>)}</ol>
    </nav>;
}
